<template>
  <div>
    <div class="d-flex align-center justify-space-between">
      <h4>Proposal TSA</h4>
      <v-btn
        class="text-capitalize"
        @click="exportData"
        dark
        depressed
        color="#016443"
      >
        Export Data
      </v-btn>
    </div>
    <div>
      <v-row align="center" class="my-2">
        <v-col cols="12" md="4">
          <p class="default_txt">Search</p>
          <v-text-field
            placeholder="Search Proposal"
            solo
            dense
            v-model="find"
            @keyup="fetchData"
            hide-details
            prepend-inner-icon="mdi-magnify"
            flat
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <p class="default_txt">University</p>
          <v-select
            dense
            flat
            solo
            @change="fetchData"
            :items="optUniv"
            item-text="name"
            item-value="id"
            v-model="univ"
            placeholder="Filter by University"
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <p class="default_txt">Category</p>
          <v-select
            dense
            flat
            solo
            @change="fetchData"
            :items="optTypeEvent"
            item-text="name"
            item-value="id"
            v-model="type"
            placeholder="Filter by Category"
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" md="2">
          <p class="default_txt">Year</p>
          <v-select
            dense
            hide-details
            :items="getYear"
            item-text="state"
            item-value="abbr"
            v-model="year"
            @change="fetchData()"
            placeholder="Filter Year"
            flat
            solo
          ></v-select>
        </v-col>
      </v-row>
    </div>

    <div>
      <v-skeleton-loader type="table-tbody" v-if="loading"></v-skeleton-loader>
      <div v-if="dataSet && !loading">
        <v-data-table
          :headers="headers"
          :items="dataSet"
          :page.sync="page"
          :items-per-page="limit"
          class="elevation-0 color_txt"
          hide-default-footer
        >
          <template v-slot:[`item.created_at`]="{ item }">
            <h5 style="font-weight: normal">
              {{ $date(item.created_at).format("MMM DD, YYYY") }}
            </h5>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fab
                    depressed
                    icon
                    x-small
                    dark
                    class="mr-2"
                    :to="`/admin/tsa/tsa-proposal/list-detail/${item.tsa.id}/${item.id}`"
                  >
                    <!-- :to="`/admin/tsa/tsa-proposal/list-detail/${item.tsa.id}`" -->

                    <v-icon color="black">mdi-eye</v-icon>
                  </v-btn>
                </template>
                <span>View</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <div class="text-center pa-3" v-if="dataSet">
          <v-pagination
            v-model="page"
            color="#006341"
            @input="fetchData"
            :length="last_page"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tsaResponse",
  computed: {
    getYear() {
      let data = [];
      let year = parseInt(this.$date().format("YYYY"));
      for (let i = 2019; i <= year; i++) {
        data.push({
          state: i,
          abbr: i,
        });
      }
      data.push({
        state: "All Year",
        abbr: "",
      });
      return data;
    },
  },
  data() {
    return {
      loading: false,
      dataSet: null,
      page: 1,
      limit: 10,
      optUniv: [],
      year: "",
      univ: "",
      find: "",
      optTypeEvent: [],
      type: "",
      headers: [
        {
          text: "Name",
          align: "start",
          value: "tsa.name",
        },
        {
          text: "Title Event",
          align: "start",
          value: "title",
        },
        {
          text: "Submitted Date",
          align: "start",
          value: "created_at",
        },
        {
          text: "Type Category",
          align: "start",
          value: "category.name",
        },
        { text: "Actions", sortable: false, value: "actions" },
      ],
    };
  },
  mounted() {
    this.fetchData();
    this.dataUniv();
    this.fetchDataType();
  },
  methods: {
    fetchDataType() {
      this.loading = true;
      let data = {
        path: `tsa-proposal/category`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.optTypeEvent = data;
          this.optTypeEvent.push({ name: "All Category", id: "" });
        })
        .catch((e) => {
          console.log("datatype", e);
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `tsa-proposal/admin/register?filter[tsa_id]=${this.univ}&page[number]=${this.page}&page[size]=${this.limit}&filter[year]=${this.year}&filter[search]=${this.find}&include=category,tsa&filter[tsa_category_id]=${this.type}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          console.log("fetchData", e);
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    dataUniv() {
      let data = {
        path: `manage/univ/get`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.optUniv = data.data;
          this.optUniv.push({ name: "All University", id: "" });
        })
        .catch((e) => {
          console.log("univ", e);
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    exportData() {
      let data = {
        path: `export/tsa/proposal`,
        body: {
          "filter[tsa_id]": this.univ,
          "filter[tsa_category_id]": this.type,
          "filter[search]": this.find,
        },
      };
      this.$store.dispatch("exportData", data);
    },
  },
};
</script>

<style scoped>
.btn {
  text-transform: unset !important;
}
</style>
